import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.visivel ? _c('div', {
    staticClass: "cfi-overlay",
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.$emit('fechar');
      }
    }
  }, [_c('div', {
    staticClass: "cfi-modal"
  }, [_c('div', {
    staticClass: "cfi-modal__header"
  }, [_c('div', [_vm._m(0), _vm.item ? _c('small', {
    staticClass: "cfi-modal__subtitle"
  }, [_vm._v(" " + _vm._s(_vm.item.descricao) + " ")]) : _vm._e()]), _c('button', {
    staticClass: "cfi-btn cfi-btn--light",
    on: {
      "click": function click($event) {
        return _vm.$emit('fechar');
      }
    }
  }, [_vm._v("✕")])]), _c('div', {
    staticClass: "cfi-modal__body"
  }, [_vm.erroInfo ? _c('div', {
    staticClass: "cfi-alert cfi-alert--danger"
  }, [_c('i', {
    staticClass: "fas fa-exclamation-triangle mr-2"
  }), _c('span', [_vm._v(" Campo obrigatório ausente: "), _c('strong', [_vm._v(_vm._s(_vm.erroInfo.campo))])])]) : _vm._e(), _vm.item ? _c('div', {
    staticClass: "cfi-item-card"
  }, [_c('div', {
    staticClass: "cfi-item-card__title"
  }, [_c('i', {
    staticClass: "fas fa-box mr-1"
  }), _c('strong', [_vm._v(_vm._s(_vm.item.descricao))])]), _c('div', {
    staticClass: "cfi-item-card__sub"
  }, [_vm._v(" Qtd: " + _vm._s(_vm.item.quantidade) + " · Unitário: R$ " + _vm._s(_vm.fmtBRL(_vm.item.valor_unitario)) + " · Total: R$ " + _vm._s(_vm.fmtBRL(_vm.item.total)) + " ")])]) : _vm._e(), _c('div', {
    staticClass: "cfi-fiscal-form"
  }, [_c('div', {
    staticClass: "cfi-form-group"
  }, [_c('label', {
    staticClass: "cfi-label"
  }, [_vm._v(" NCM "), _vm.erroInfo && _vm.erroInfo.campo === 'NCM' ? _c('span', {
    staticClass: "cfi-badge cfi-badge--danger ml-1"
  }, [_vm._v("campo faltante")]) : _vm._e()]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.ncm,
      expression: "form.ncm"
    }],
    ref: "ncmInput",
    staticClass: "cfi-input",
    class: {
      'cfi-input--erro': _vm.erros.ncm
    },
    attrs: {
      "type": "text",
      "maxlength": "10",
      "placeholder": "ex: 22021000  (8 dígitos)"
    },
    domProps: {
      "value": _vm.form.ncm
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "ncm", $event.target.value);
      }, function ($event) {
        _vm.erros.ncm = null;
      }]
    }
  }), _vm.erros.ncm ? _c('small', {
    staticClass: "cfi-erro-msg"
  }, [_vm._v(_vm._s(_vm.erros.ncm))]) : _vm._e(), _c('small', {
    staticClass: "cfi-hint"
  }, [_vm._v("Nomenclatura Comum do Mercosul — 8 dígitos obrigatórios.")])]), _c('div', {
    staticClass: "cfi-form-group"
  }, [_c('label', {
    staticClass: "cfi-label"
  }, [_vm._v(" CFOP "), _vm.erroInfo && _vm.erroInfo.campo === 'CFOP' ? _c('span', {
    staticClass: "cfi-badge cfi-badge--danger ml-1"
  }, [_vm._v("campo faltante")]) : _vm._e()]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.cfop,
      expression: "form.cfop"
    }],
    staticClass: "cfi-input",
    class: {
      'cfi-input--erro': _vm.erros.cfop
    },
    attrs: {
      "type": "text",
      "maxlength": "5",
      "placeholder": "ex: 5102  (4 dígitos)"
    },
    domProps: {
      "value": _vm.form.cfop
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "cfop", $event.target.value);
      }, function ($event) {
        _vm.erros.cfop = null;
      }]
    }
  }), _vm.erros.cfop ? _c('small', {
    staticClass: "cfi-erro-msg"
  }, [_vm._v(_vm._s(_vm.erros.cfop))]) : _vm._e(), _vm._m(1)]), _c('div', {
    staticClass: "cfi-form-group"
  }, [_c('label', {
    staticClass: "cfi-label"
  }, [_vm._v(" CSOSN "), _vm.erroInfo && (_vm.erroInfo.campo === 'CSOSN' || _vm.erroInfo.campo === 'CST') ? _c('span', {
    staticClass: "cfi-badge cfi-badge--danger ml-1"
  }, [_vm._v("campo faltante")]) : _vm._e()]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.csosn,
      expression: "form.csosn"
    }],
    staticClass: "cfi-select",
    class: {
      'cfi-input--erro': _vm.erros.csosn
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form, "csosn", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("— selecione —")]), _c('option', {
    attrs: {
      "value": "102"
    }
  }, [_vm._v("102 – Tributada pelo Simples Nacional sem permissão de crédito")]), _c('option', {
    attrs: {
      "value": "103"
    }
  }, [_vm._v("103 – Isenção para faixa de receita bruta")]), _c('option', {
    attrs: {
      "value": "300"
    }
  }, [_vm._v("300 – Imune")]), _c('option', {
    attrs: {
      "value": "400"
    }
  }, [_vm._v("400 – Não tributada pelo Simples Nacional")]), _c('option', {
    attrs: {
      "value": "500"
    }
  }, [_vm._v("500 – ICMS cobrado por substituição tributária")]), _c('option', {
    attrs: {
      "value": "900"
    }
  }, [_vm._v("900 – Outros (Regime Normal)")])]), _vm.erros.csosn ? _c('small', {
    staticClass: "cfi-erro-msg"
  }, [_vm._v(_vm._s(_vm.erros.csosn))]) : _vm._e(), _vm._m(2)]), _c('div', {
    staticClass: "cfi-form-group"
  }, [_vm._m(3), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.cst_icms,
      expression: "form.cst_icms"
    }],
    staticClass: "cfi-select",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form, "cst_icms", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("— não se aplica / Simples Nacional —")]), _c('option', {
    attrs: {
      "value": "00"
    }
  }, [_vm._v("00 – Tributada integralmente")]), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("20 – Com redução de BC")]), _c('option', {
    attrs: {
      "value": "40"
    }
  }, [_vm._v("40 – Isenta")]), _c('option', {
    attrs: {
      "value": "41"
    }
  }, [_vm._v("41 – Não tributada")]), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50 – Suspensão")]), _c('option', {
    attrs: {
      "value": "60"
    }
  }, [_vm._v("60 – ICMS cobrado anteriormente por ST")])]), _c('small', {
    staticClass: "cfi-hint"
  }, [_vm._v("Preencha somente se o emitente é Regime Normal (CRT 3).")])]), _c('div', {
    staticClass: "cfi-form-group"
  }, [_c('label', {
    staticClass: "cfi-label"
  }, [_vm._v("Origem da Mercadoria")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.origem,
      expression: "form.origem"
    }],
    staticClass: "cfi-select",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form, "origem", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("0 – Nacional")]), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1 – Estrangeira – importação direta")]), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2 – Estrangeira – adquirida no mercado interno")]), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3 – Nacional com conteúdo externo > 40%")]), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4 – Nacional – processo produtivo básico")]), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5 – Nacional – conteúdo externo ≤ 40%")]), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6 – Estrangeira – importação direta (sem similar nacional)")]), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("7 – Estrangeira – adquirida no mercado (sem similar nacional)")]), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("8 – Nacional – conteúdo externo > 70%")])])]), _c('div', {
    staticClass: "cfi-form-group"
  }, [_c('label', {
    staticClass: "cfi-label"
  }, [_vm._v("CST PIS")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.cst_pis,
      expression: "form.cst_pis"
    }],
    staticClass: "cfi-select",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form, "cst_pis", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "07"
    }
  }, [_vm._v("07 – Operação Isenta da Contribuição")]), _c('option', {
    attrs: {
      "value": "08"
    }
  }, [_vm._v("08 – Operação sem Incidência da Contribuição")]), _c('option', {
    attrs: {
      "value": "49"
    }
  }, [_vm._v("49 – Outras Operações de Saída")]), _c('option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("99 – Outras Operações")])])]), _c('div', {
    staticClass: "cfi-form-group"
  }, [_c('label', {
    staticClass: "cfi-label"
  }, [_vm._v("CST COFINS")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.cst_cofins,
      expression: "form.cst_cofins"
    }],
    staticClass: "cfi-select",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form, "cst_cofins", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "07"
    }
  }, [_vm._v("07 – Operação Isenta da Contribuição")]), _c('option', {
    attrs: {
      "value": "08"
    }
  }, [_vm._v("08 – Operação sem Incidência da Contribuição")]), _c('option', {
    attrs: {
      "value": "49"
    }
  }, [_vm._v("49 – Outras Operações de Saída")]), _c('option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("99 – Outras Operações")])])])]), _vm.erroGeral ? _c('div', {
    staticClass: "cfi-alert cfi-alert--danger mt-2"
  }, [_c('i', {
    staticClass: "fas fa-exclamation-circle mr-1"
  }), _vm._v(_vm._s(_vm.erroGeral) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "cfi-modal__footer"
  }, [_c('button', {
    staticClass: "cfi-btn cfi-btn--secondary",
    on: {
      "click": function click($event) {
        return _vm.$emit('fechar');
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "cfi-btn cfi-btn--primary",
    on: {
      "click": _vm.salvar
    }
  }, [_c('i', {
    staticClass: "fas fa-check mr-1"
  }), _vm._v("Salvar e Aplicar ")])])])]) : _vm._e();
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('h4', {
    staticClass: "cfi-modal__title"
  }, [_c('i', {
    staticClass: "fas fa-tools mr-2"
  }), _vm._v("Corrigir Dados Fiscais do Item ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('small', {
    staticClass: "cfi-hint"
  }, [_vm._v("Para NFC-e de venda interna, use "), _c('strong', [_vm._v("5102")]), _vm._v(".")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('small', {
    staticClass: "cfi-hint"
  }, [_vm._v("Para NFC-e Simples Nacional sem crédito, use "), _c('strong', [_vm._v("102")]), _vm._v(".")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('label', {
    staticClass: "cfi-label"
  }, [_vm._v("CST ICMS "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("(Regime Normal)")])]);
}];
export { render, staticRenderFns };